import React, { useRef } from 'react'
import {
    useBuyBonusStore,
    useConfigurationStore,
    useCountdownFSBonusStore,
    useFreeBuyBonusStore,
    useFreeSpinsBonusesStore,
    useLuckySpinsStore,
    useNavigationStore,
    useSpinButtonSectionStore,
} from '@stores'
import { withAutoBlur } from '@utils/misc'

import amuseBoostImage from '@assets/amuse-boost/amuse-boost.svg'
import { useOpacityToggle } from '@hooks'
import { ChangeOpacityComponents } from 'game-ui-types'

interface AmuseBoostButtonProps {
    onClick: () => void
}

const AmuseBoostButton: React.FC<AmuseBoostButtonProps> = ({ onClick }) => {
    const styles = useConfigurationStore((s) => s.getComponentConfig('AmuseBoostButton').styles)
    const dimensions = useConfigurationStore((s) => s.getComponentConfig('AmuseBoostButton').dimensions)
    const position = useConfigurationStore((s) => s.getComponentConfig('AmuseBoostButton').position)

    const isAutoplaySectionOpened = useSpinButtonSectionStore((s) => s.isAutoplaySectionOpened)
    const isBetSectionOpened = useSpinButtonSectionStore((s) => s.isBetSectionOpened)
    const isLongPress = useSpinButtonSectionStore((s) => s.isLongPress)
    const isSpaceKeyPressed = useSpinButtonSectionStore((s) => s.isSpaceKeyPressed)

    const showBuyBonusModal = useBuyBonusStore((s) => s.showModal)
    const isCFSModalOpened = useCountdownFSBonusStore((s) => s.isModalOpened)
    const isFSBModalOpened = useFreeSpinsBonusesStore((s) => s.isModalOpened)
    const isFBBModalOpened = useFreeBuyBonusStore((s) => s.isModalOpened)
    const isLSBModalOpened = useLuckySpinsStore((s) => s.isModalOpened)

    const isMenuOpen = useNavigationStore((s) => s.isMenuOpen)

    const amuseBoostComponent = useRef<HTMLButtonElement | null>(null)

    const { isComponentInteractive, opacity } = useOpacityToggle(
        ChangeOpacityComponents.BUY_BONUS_BUTTON,
        amuseBoostComponent,
        0,
        false
    )
    const isBonusModalOpenedRef =
        showBuyBonusModal || isFBBModalOpened || isFSBModalOpened || isLSBModalOpened || isCFSModalOpened
    const activeConditions = isComponentInteractive && !isBonusModalOpenedRef && (isLongPress || isSpaceKeyPressed)

    const handleClick = () => {
        if (amuseBoostComponent.current) {
            onClick()
        }
    }

    return (
        <button
            id="amuse-boost-button"
            ref={amuseBoostComponent}
            className={`absolute focus:outline-none ${styles ?? ''}`}
            onClick={withAutoBlur(handleClick)}
            style={{
                ...dimensions,
                ...position,
                zIndex: isAutoplaySectionOpened || isBetSectionOpened || isMenuOpen ? 10 : 31,
                backgroundImage: `url(${amuseBoostImage})`,
                backgroundRepeat: 'no-repeat',
                backgroundSize: 'cover',
                opacity: activeConditions ? 0.5 : opacity,
                pointerEvents: activeConditions ? 'none' : 'auto',
            }}
        ></button>
    )
}

export default AmuseBoostButton
